/**
 * HeroSearchForm — the hero's MOBILE search control.
 *
 * Below `md` the hero no longer renders the desktop combobox inline (which
 * dropped a suggestions panel into a 393 px hero and opened nothing); it renders
 * the shared {@link SearchForm} — a native `<form method="get">` onto the
 * browse hub, enhanced into the full-screen `SearchOverlay` once hydrated.
 *
 * It exists as its own module because the rotating example placeholder is
 * STATE, and `HeroSection` is the static half of the hero. Folding the hook
 * into the section would re-render the whole hero — background `<picture>`,
 * preload links, logo tile — every three seconds.
 *
 * The field takes `rent` because the home page has no mode context; that is the
 * same default `SearchBar` carries for the hero, so the two halves of the hero
 * send a reader to the same hub.
 */
import { SearchForm } from '@/shared/components/search';
import { useTranslations } from '@/shared/i18n/useTranslations';
import { HOME_SEARCH_DEFAULT_MODE } from '@letsgethome/lib/constants';
import { urlModeFor } from '@letsgethome/routes';

import { useHeroSearchPlaceholder } from './useRotatingPlaceholder';

export function HeroSearchForm() {
  const t = useTranslations('search');
  // The home hero's URL carries no listings query, so the field is always
  // empty here and there is no value to pause the rotation for.
  const example = useHeroSearchPlaceholder('');

  // Home has no mode of its own: the ONE declared default, never a private
  // "rent" (epoch 44).
  return (
    <SearchForm
      mode={urlModeFor(HOME_SEARCH_DEFAULT_MODE)}
      placeholder={example ?? t('placeholder')}
      variant="hero"
    />
  );
}
